// Translations for PFC Resource+Connect Intake App
// Languages: English, Spanish, French, Polish

export const translations = {
  en: {
    // Kiosk Home
    welcome: "Welcome",
    welcomeMessage: "Pope Francis Center Chicago serves those in need. Let us help you today.",
    howToProceed: "How would you like to proceed?",
    startIntake: "Start New Intake Form",
    firstVisit: "First Visit",
    firstVisitSubtitle: "I'm new to Pope Francis Center",
    beenHereBefore: "I've Been Here Before",
    beenHereBeforeSubtitle: "Returning — look me up by name and date of birth",
    returningClient: "Returning Client",
    returningLookupTitle: "Welcome back!",
    returningLookupHelp: "Please enter your name and date of birth so we can look up your record.",
    lookingUp: "Looking you up...",
    clientNotFound: "We couldn't find a record matching those details.",
    clientNotFoundHelp: "Please check your spelling and try again, or choose another option below.",
    tryAgain: "Try Again",
    requestCaseManager: "Ask Case Manager for Help",
    continueAsNew: "Continue as a New Client",
    caseManagerFlagged: "A case manager has been notified. Please take a seat — someone will be with you shortly.",
    welcomeBackReview: "Welcome back! Please review your information and update anything that has changed, then select the services you need today.",
    foundYou: "We found your record!",
    continueBtn: "Continue",
    lookUpMe: "Look Me Up",
    staffLogin: "Staff Login",
    needAssistance: "If you need assistance, please ask a staff member or email support@popefranciscenter-svdp.org",
    
    // Language selector
    selectLanguage: "Select Language",
    english: "English",
    spanish: "Español",
    french: "Français",
    polish: "Polski",
    
    // Audio/TTS
    audioAssistance: "Audio Assistance",
    readAloud: "Read Aloud",
    stopReading: "Stop",
    audioOn: "On",
    audioOff: "Off",
    autoRead: "Auto-read",
    ttsDemographics: "Personal Information. Please enter your name, date of birth, and gender.",
    ttsContact: "Contact and Address. Please enter your address, phone number, and emergency contact.",
    ttsLiving: "Living Situation. Tell us about your current housing and household.",
    ttsServices: "What brought you to Pope Francis Center today? Please select all services you need help with.",
    ttsConsent: "Please review and sign the consent forms.",
    
    // Navigation
    next: "Next",
    previous: "Previous",
    cancel: "Cancel",
    submit: "Submit Form",
    submitting: "Submitting...",
    backToHome: "Return to Home",
    back: "Back",
    
    // Steps
    step: "Step",
    of: "of",
    
    // Step titles
    personalInfo: "Personal Information",
    contactAddress: "Contact & Address",
    emergencyContact: "Emergency Contact",
    demographics: "Demographics",
    livingSituation: "Living Situation",
    yourNeeds: "Your Needs",
    household: "Household Information",
    incomeAndBenefits: "Income & Benefits",
    consent: "Consent",
    
    // Personal Info
    tellUsAboutYourself: "Please tell us about yourself.",
    firstName: "First Name",
    lastName: "Last Name",
    middleInitial: "Middle Initial",
    dateOfBirth: "Date of Birth",
    month: "Month",
    day: "Day",
    year: "Year",
    ssn: "SSN (Optional)",
    gender: "Gender",
    male: "Male",
    female: "Female",
    other: "Other",
    preferNotToSay: "Prefer not to say",
    
    // Contact
    streetAddress: "Street Address",
    city: "City",
    state: "State",
    zipCode: "Zip Code",
    phoneNumber: "Phone Number",
    emailAddress: "Email Address",
    
    // Emergency Contact
    contactName: "Contact Name",
    contactPhone: "Contact Phone",
    discretionRequired: "Should we be careful about what we say when calling this person?",
    emergencyContactDesc: "Please provide someone we can contact in case of an emergency.",
    
    // Demographics
    hispanicLatino: "Are you Hispanic/Latino?",
    yes: "Yes",
    no: "No",
    race: "Race (select all that apply)",
    asian: "Asian",
    blackAfricanAmerican: "Black or African American",
    nativeHawaiian: "Native Hawaiian/Pacific Islander",
    white: "White",
    americanIndian: "American Indian",
    alaskaNative: "Alaska Native",
    relationshipStatus: "Relationship Status",
    single: "Single",
    singleLivingWithPartner: "Single/Living with Partner",
    married: "Married",
    divorced: "Divorced",
    separated: "Separated",
    widowed: "Widowed",
    
    // Living Situation
    selectLivingSituation: "Please select your current living situation.",
    onStreet: "On Street",
    shelter: "Shelter",
    transitional: "Transitional Housing",
    groupHome: "Group Home",
    drugTreatment: "Drug Treatment Residence",
    sro: "SRO",
    rental: "Permanent/Rental",
    ownHome: "Own Home",
    familyFriends: "Family/Friends",
    temporary: "Temporary",
    pleaseSpecify: "Please specify",
    
    // Needs
    howDidYouHear: "How did you hear about Pope Francis Center?",
    referralPlaceholder: "Friend, church, website, etc.",
    whatDoYouNeed: "What do you need help with today?",
    needsPlaceholder: "Please describe your immediate needs and situation...",
    
    // Household
    householdSize: "Household Size (including yourself)",
    numberOfAdults: "Number of Adults",
    numberOfChildren: "Number of Children",
    tellUsAboutHousehold: "Tell us about who lives in your household.",
    
    // Income
    monthlyIncomeTitle: "Monthly Income & Benefits",
    incomeDescription: "Enter your monthly income from each source (leave blank if none).",
    employment: "Employment",
    socialSecurity: "Social Security",
    ssi: "SSI",
    ssd: "SSD",
    childSupport: "Child Support",
    tanf: "TANF",
    foodStamps: "Food Stamps",
    unemployment: "Unemployment",
    veteransAssistance: "Veterans Assistance",
    pension: "Pension",
    disabilityInsurance: "Disability Insurance",
    otherIncome: "Other Income",
    totalMonthlyIncome: "Total Monthly Income",
    additionalHouseholdIncome: "Additional Income from Other Household Members",
    
    // Services
    whatBroughtYou: "What brought you to Pope Francis Center today?",
    selectServices: "Please select all the services you need help with. We're here to serve you.",
    servicesSelected: "Services selected",
    tellUsWhatYouNeed: "Please tell us what you need",
    describeNeeds: "Please describe what brought you here today...",
    serviceHomelessness: "Navigating homelessness issues",
    serviceHousing: "Housing assistance (applying for housing)",
    serviceBenefits: "Public benefits (LINK, TANF, Medicaid, etc.)",
    serviceReferrals: "Resource referrals (food pantry, ESL, immigration, re-entry, healthcare)",
    serviceFinancial: "Financial literacy counseling",
    serviceJob: "Job readiness (resumes, job search, applications)",
    serviceMailDrop: "Mail drop services (use PFC as mailing address)",
    serviceNotary: "Homeless Waiver",
    servicePfcId: "Pope Francis Center ID",
    serviceId: "Birth certificate / State ID assistance",
    serviceInternet: "Internet help & access",
    
    // Consent
    informedConsent: "Informed Consent",
    informedConsentText: "I authorize Pope Francis Center Chicago to collect information during the enrollment/registration process. This consent form includes all questions about me, my family, work history, medical history, mental health history, and use of drugs and/or alcohol. This includes all appointments made for me and help given to me by Pope Francis Center Chicago. I understand that I can refuse to talk about mental health, alcohol use, and drug use. I am giving my consent within limits of my legal authority. I understand that I can take away this consent at any time in writing. A photocopy/fax copy of this consent will be legally the same as the original.",
    consentIntro: "Please review and agree to the following consent forms based on the services you selected.",
    iAgree: "I agree to the above terms",
    signature: "Signature",
    clear: "Clear",
    mailDropConsent: "Mail-Drop Consent (Optional)",
    mailDropText: "PFC offers unofficial mail drop services. Mail can only be picked up by you with valid ID. Mail will be kept for 2 weeks only.",
    useMailDrop: "I would like to use the mail-drop service",
    idCardConsent: "Identification Card Consent (Optional)",
    idCardText: "PFC offers unofficial identification cards for active clients, for PFC use only. This ID can be used for picking up mail and receiving services at PFC events.",
    receiveIdCard: "I would like to receive a PFC identification card",
    doNotShare: "Information I do NOT want shared (optional):",
    doNotSharePlaceholder: "List any information you want kept confidential...",
    
    // Success
    thankYou: "Thank You!",
    submissionSuccess: "Your intake form has been submitted successfully.",
    yourClientId: "Your Client ID",
    caseManagerContact: "A case manager will review your information and contact you soon. Questions? Email support@popefranciscenter-svdp.org",
    
    // Login
    signIn: "Sign In",
    signInDesc: "Sign in to access the intake management system",
    username: "Username",
    password: "Password",
    enterUsername: "Enter username",
    enterPassword: "Enter password",
    signingIn: "Signing in...",
    backToKiosk: "← Back to Kiosk Mode",
    welcomeBack: "Welcome back!",
    
    // Dashboard
    intakeDashboard: "Intake Dashboard",
    manageIntakes: "Manage client intake submissions",
    searchClients: "Search clients...",
    dashboard: "Dashboard",
    pendingReview: "Pending Review",
    approved: "Approved",
    newIntake: "New Intake",
    manageUsers: "Manage Users",
    signOut: "Sign Out",
    total: "Total",
    pending: "Pending",
    exported: "Exported",
    today: "Today",
    allIntakes: "All Intakes",
    clientId: "Client ID",
    name: "Name",
    status: "Status",
    created: "Created",
    actions: "Actions",
    noIntakesFound: "No intakes found",
    
    // Review
    reviewNotes: "Review Notes",
    addNotesPlaceholder: "Add notes about this intake...",
    approve: "Approve",
    reject: "Reject",
    exportForServWare: "Export for ServWare",
    submittedOn: "Submitted on",
    via: "via",
    entry: "entry",
    reviewedBy: "Reviewed by",
    on: "on",
    
    // User Management
    addNewUser: "Add New User",
    fullName: "Full Name",
    role: "Role",
    admin: "Admin",
    caseManager: "Case Manager",
    hospitalityManager: "Hospitality Manager",
    createUser: "Create User",
    creating: "Creating...",
    currentUsers: "Current Users",
    userCreated: "User created",
    userDeleted: "User deleted",
    
    // Misc
    required: "required",
    optional: "optional",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    
    // Conference Referral
    conferenceReferral: "SVdP Conference Referral",
    referralDescription: "Submit a referral for someone who needs assistance at Pope Francis Center",
    referringConference: "Referring Conference",
    selectConference: "Select Conference",
    organizationName: "Organization Name",
    enterOrgName: "Enter organization name",
    contactEmail: "Contact Email",
    contactPhone: "Contact Phone",
    personBeingReferred: "Person Being Referred",
    enterFullName: "Enter full name",
    referralDetails: "Referral Details",
    reasonForReferral: "Reason for Referral",
    describeReason: "Describe why this person is being referred...",
    additionalInfo: "Additional Information",
    anyOtherInfo: "Any other relevant information...",
    submitReferral: "Submit Referral",
    referralSubmitted: "Referral submitted successfully!",
    referralReceived: "Your referral has been received. Our staff will be notified and will prepare to assist when the client arrives.",
    referralId: "Referral ID",
    pleaseFillRequired: "Please fill in all required fields",
    pleaseProvideOrgName: "Please provide your organization name",
    pendingReferrals: "Pending Referrals",
    convertToIntake: "Convert to Intake",
    cancelReferral: "Cancel Referral",
    referralConverted: "Referral converted to intake",
    referralCancelled: "Referral cancelled",
  },
  
  es: {
    // Kiosk Home
    welcome: "Bienvenido",
    welcomeMessage: "El Centro Papa Francisco de Chicago sirve a los necesitados. Permítanos ayudarle hoy.",
    howToProceed: "¿Cómo desea proceder?",
    startIntake: "Comenzar Nuevo Formulario",
    firstVisit: "Primera Visita",
    firstVisitSubtitle: "Soy nuevo en el Centro Papa Francisco",
    beenHereBefore: "He Estado Aquí Antes",
    beenHereBeforeSubtitle: "Cliente recurrente — búsqueme por nombre y fecha de nacimiento",
    returningClient: "Cliente Recurrente",
    returningLookupTitle: "¡Bienvenido de nuevo!",
    returningLookupHelp: "Por favor ingrese su nombre y fecha de nacimiento para buscar su registro.",
    lookingUp: "Buscando...",
    clientNotFound: "No encontramos un registro con esos datos.",
    clientNotFoundHelp: "Por favor verifique la ortografía e intente de nuevo, o elija otra opción.",
    tryAgain: "Intentar de Nuevo",
    requestCaseManager: "Pedir Ayuda al Administrador de Casos",
    continueAsNew: "Continuar como Cliente Nuevo",
    caseManagerFlagged: "Se ha notificado a un administrador de casos. Por favor tome asiento — alguien le atenderá en breve.",
    welcomeBackReview: "¡Bienvenido de nuevo! Por favor revise su información y actualice cualquier cosa que haya cambiado, luego seleccione los servicios que necesita hoy.",
    foundYou: "¡Encontramos su registro!",
    continueBtn: "Continuar",
    lookUpMe: "Buscarme",
    staffLogin: "Inicio de Sesión del Personal",
    needAssistance: "Si necesita ayuda, pregunte a un miembro del personal o envíe un correo a support@popefranciscenter-svdp.org",
    
    // Language selector
    selectLanguage: "Seleccionar Idioma",
    english: "English",
    spanish: "Español",
    french: "Français",
    polish: "Polski",
    
    // Audio/TTS
    ttsDemographics: "Información Personal. Por favor ingrese su nombre, fecha de nacimiento y género.",
    ttsContact: "Contacto y Dirección. Por favor ingrese su dirección, número de teléfono y contacto de emergencia.",
    ttsLiving: "Situación de Vivienda. Cuéntenos sobre su vivienda actual y hogar.",
    ttsServices: "¿Qué lo trajo al Centro Papa Francisco hoy? Por favor seleccione todos los servicios que necesita.",
    ttsConsent: "Por favor revise y firme los formularios de consentimiento.",
    
    // Navigation
    next: "Siguiente",
    previous: "Anterior",
    cancel: "Cancelar",
    submit: "Enviar Formulario",
    submitting: "Enviando...",
    backToHome: "Volver al Inicio",
    back: "Atrás",
    
    // Steps
    step: "Paso",
    of: "de",
    
    // Step titles
    personalInfo: "Información Personal",
    contactAddress: "Contacto y Dirección",
    emergencyContact: "Contacto de Emergencia",
    demographics: "Demografía",
    livingSituation: "Situación de Vivienda",
    yourNeeds: "Sus Necesidades",
    household: "Información del Hogar",
    incomeAndBenefits: "Ingresos y Beneficios",
    consent: "Consentimiento",
    
    // Personal Info
    tellUsAboutYourself: "Por favor cuéntenos sobre usted.",
    firstName: "Nombre",
    lastName: "Apellido",
    middleInitial: "Inicial del Segundo Nombre",
    dateOfBirth: "Fecha de Nacimiento",
    month: "Mes",
    day: "Día",
    year: "Año",
    ssn: "Número de Seguro Social (Opcional)",
    gender: "Género",
    male: "Masculino",
    female: "Femenino",
    other: "Otro",
    preferNotToSay: "Prefiero no decir",
    
    // Contact
    streetAddress: "Dirección",
    city: "Ciudad",
    state: "Estado",
    zipCode: "Código Postal",
    phoneNumber: "Número de Teléfono",
    emailAddress: "Correo Electrónico",
    
    // Emergency Contact
    contactName: "Nombre del Contacto",
    contactPhone: "Teléfono del Contacto",
    discretionRequired: "¿Debemos tener cuidado con lo que decimos al llamar a esta persona?",
    emergencyContactDesc: "Por favor proporcione a alguien que podamos contactar en caso de emergencia.",
    
    // Demographics
    hispanicLatino: "¿Es usted Hispano/Latino?",
    yes: "Sí",
    no: "No",
    race: "Raza (seleccione todas las que apliquen)",
    asian: "Asiático",
    blackAfricanAmerican: "Negro o Afroamericano",
    nativeHawaiian: "Nativo de Hawái/Islas del Pacífico",
    white: "Blanco",
    americanIndian: "Indio Americano",
    alaskaNative: "Nativo de Alaska",
    relationshipStatus: "Estado Civil",
    single: "Soltero/a",
    singleLivingWithPartner: "Soltero/a Viviendo con Pareja",
    married: "Casado/a",
    divorced: "Divorciado/a",
    separated: "Separado/a",
    widowed: "Viudo/a",
    
    // Living Situation
    selectLivingSituation: "Por favor seleccione su situación de vivienda actual.",
    onStreet: "En la Calle",
    shelter: "Refugio",
    transitional: "Vivienda de Transición",
    groupHome: "Hogar Grupal",
    drugTreatment: "Residencia de Tratamiento de Drogas",
    sro: "SRO",
    rental: "Permanente/Alquiler",
    ownHome: "Casa Propia",
    familyFriends: "Familia/Amigos",
    temporary: "Temporal",
    pleaseSpecify: "Por favor especifique",
    
    // Needs
    howDidYouHear: "¿Cómo se enteró del Centro Papa Francisco?",
    referralPlaceholder: "Amigo, iglesia, sitio web, etc.",
    whatDoYouNeed: "¿Con qué necesita ayuda hoy?",
    needsPlaceholder: "Por favor describa sus necesidades inmediatas y su situación...",
    
    // Household
    householdSize: "Tamaño del Hogar (incluyéndose usted)",
    numberOfAdults: "Número de Adultos",
    numberOfChildren: "Número de Niños",
    tellUsAboutHousehold: "Cuéntenos sobre quiénes viven en su hogar.",
    
    // Income
    monthlyIncomeTitle: "Ingresos y Beneficios Mensuales",
    incomeDescription: "Ingrese sus ingresos mensuales de cada fuente (deje en blanco si no tiene).",
    employment: "Empleo",
    socialSecurity: "Seguro Social",
    ssi: "SSI",
    ssd: "SSD",
    childSupport: "Manutención de Hijos",
    tanf: "TANF",
    foodStamps: "Cupones de Alimentos",
    unemployment: "Desempleo",
    veteransAssistance: "Asistencia para Veteranos",
    pension: "Pensión",
    disabilityInsurance: "Seguro de Discapacidad",
    otherIncome: "Otros Ingresos",
    totalMonthlyIncome: "Ingreso Mensual Total",
    additionalHouseholdIncome: "Ingresos Adicionales de Otros Miembros del Hogar",
    
    // Services
    whatBroughtYou: "¿Qué lo trajo al Centro Papa Francisco hoy?",
    selectServices: "Por favor seleccione todos los servicios con los que necesita ayuda. Estamos aquí para servirle.",
    servicesSelected: "Servicios seleccionados",
    tellUsWhatYouNeed: "Por favor cuéntenos lo que necesita",
    describeNeeds: "Por favor describa lo que lo trajo aquí hoy...",
    serviceHomelessness: "Navegando problemas de falta de vivienda",
    serviceHousing: "Asistencia de vivienda (solicitar vivienda)",
    serviceBenefits: "Beneficios públicos (LINK, TANF, Medicaid, etc.)",
    serviceReferrals: "Referencias de recursos (despensa de alimentos, ESL, inmigración, reinserción, atención médica)",
    serviceFinancial: "Asesoría de educación financiera",
    serviceJob: "Preparación laboral (currículums, búsqueda de empleo, solicitudes)",
    serviceMailDrop: "Servicios de buzón (usar PFC como dirección postal)",
    serviceNotary: "Exención para Personas sin Hogar",
    servicePfcId: "Identificación del Centro Papa Francisco",
    serviceId: "Asistencia con certificado de nacimiento / identificación estatal",
    serviceInternet: "Ayuda y acceso a Internet",
    
    // Consent
    informedConsent: "Consentimiento Informado",
    informedConsentText: "Autorizo al Centro Papa Francisco de Chicago a recopilar información durante el proceso de inscripción/registro. Este formulario de consentimiento incluye todas las preguntas sobre mí, mi familia, historial laboral, historial médico, historial de salud mental y uso de drogas y/o alcohol. Esto incluye todas las citas hechas para mí y la ayuda brindada por el Centro Papa Francisco de Chicago. Entiendo que puedo negarme a hablar sobre salud mental, uso de alcohol y uso de drogas. Estoy dando mi consentimiento dentro de los límites de mi autoridad legal. Entiendo que puedo retirar este consentimiento en cualquier momento por escrito. Una fotocopia/fax de este consentimiento será legalmente igual que el original.",
    consentIntro: "Por favor revise y acepte los siguientes formularios de consentimiento según los servicios que seleccionó.",
    iAgree: "Acepto los términos anteriores",
    signature: "Firma",
    clear: "Borrar",
    mailDropConsent: "Consentimiento de Correo (Opcional)",
    mailDropText: "PFC ofrece servicios de buzón no oficiales. El correo solo puede ser recogido por usted con identificación válida. El correo se guardará solo por 2 semanas.",
    useMailDrop: "Me gustaría usar el servicio de buzón",
    idCardConsent: "Consentimiento de Tarjeta de Identificación (Opcional)",
    idCardText: "PFC ofrece tarjetas de identificación no oficiales para clientes activos, solo para uso de PFC. Esta identificación puede usarse para recoger correo y recibir servicios en eventos de PFC.",
    receiveIdCard: "Me gustaría recibir una tarjeta de identificación de PFC",
    doNotShare: "Información que NO quiero compartir (opcional):",
    doNotSharePlaceholder: "Liste cualquier información que desee mantener confidencial...",
    
    // Success
    thankYou: "¡Gracias!",
    submissionSuccess: "Su formulario de admisión ha sido enviado exitosamente.",
    yourClientId: "Su ID de Cliente",
    caseManagerContact: "Un administrador de casos revisará su información y lo contactará pronto. ¿Preguntas? Correo: support@popefranciscenter-svdp.org",
    
    // Login
    signIn: "Iniciar Sesión",
    signInDesc: "Inicie sesión para acceder al sistema de gestión de admisiones",
    username: "Usuario",
    password: "Contraseña",
    enterUsername: "Ingrese usuario",
    enterPassword: "Ingrese contraseña",
    signingIn: "Iniciando sesión...",
    backToKiosk: "← Volver al Modo Quiosco",
    welcomeBack: "¡Bienvenido de nuevo!",
    
    // Dashboard (kept in English for staff)
    intakeDashboard: "Panel de Admisiones",
    manageIntakes: "Gestionar admisiones de clientes",
    searchClients: "Buscar clientes...",
    dashboard: "Panel",
    pendingReview: "Revisión Pendiente",
    approved: "Aprobado",
    newIntake: "Nueva Admisión",
    manageUsers: "Gestionar Usuarios",
    signOut: "Cerrar Sesión",
    total: "Total",
    pending: "Pendiente",
    exported: "Exportado",
    today: "Hoy",
    allIntakes: "Todas las Admisiones",
    clientId: "ID de Cliente",
    name: "Nombre",
    status: "Estado",
    created: "Creado",
    actions: "Acciones",
    noIntakesFound: "No se encontraron admisiones",
    
    // Review
    reviewNotes: "Notas de Revisión",
    addNotesPlaceholder: "Agregar notas sobre esta admisión...",
    approve: "Aprobar",
    reject: "Rechazar",
    exportForServWare: "Exportar para ServWare",
    submittedOn: "Enviado el",
    via: "vía",
    entry: "entrada",
    reviewedBy: "Revisado por",
    on: "el",
    
    // User Management
    addNewUser: "Agregar Nuevo Usuario",
    fullName: "Nombre Completo",
    role: "Rol",
    admin: "Administrador",
    caseManager: "Administrador de Casos",
    hospitalityManager: "Gerente de Hospitalidad",
    createUser: "Crear Usuario",
    creating: "Creando...",
    currentUsers: "Usuarios Actuales",
    userCreated: "Usuario creado",
    userDeleted: "Usuario eliminado",
    
    // Misc
    required: "requerido",
    optional: "opcional",
    loading: "Cargando...",
    error: "Error",
    success: "Éxito",
    
    // Conference Referral
    conferenceReferral: "Referencia de Conferencia SVdP",
    referralDescription: "Envíe una referencia para alguien que necesita asistencia en el Centro Papa Francisco",
    referringConference: "Conferencia que Refiere",
    selectConference: "Seleccionar Conferencia",
    organizationName: "Nombre de la Organización",
    enterOrgName: "Ingrese el nombre de la organización",
    contactEmail: "Correo de Contacto",
    contactPhone: "Teléfono de Contacto",
    personBeingReferred: "Persona Referida",
    enterFullName: "Ingrese el nombre completo",
    referralDetails: "Detalles de la Referencia",
    reasonForReferral: "Motivo de la Referencia",
    describeReason: "Describa por qué se refiere a esta persona...",
    additionalInfo: "Información Adicional",
    anyOtherInfo: "Cualquier otra información relevante...",
    submitReferral: "Enviar Referencia",
    referralSubmitted: "¡Referencia enviada exitosamente!",
    referralReceived: "Su referencia ha sido recibida. Nuestro personal será notificado y se preparará para asistir cuando llegue el cliente.",
    referralId: "ID de Referencia",
    pleaseFillRequired: "Por favor complete todos los campos requeridos",
    pleaseProvideOrgName: "Por favor proporcione el nombre de su organización",
    pendingReferrals: "Referencias Pendientes",
    convertToIntake: "Convertir a Admisión",
    cancelReferral: "Cancelar Referencia",
    referralConverted: "Referencia convertida a admisión",
    referralCancelled: "Referencia cancelada",
  },
  
  fr: {
    // Kiosk Home
    welcome: "Bienvenue",
    welcomeMessage: "Le Centre Pape François de Chicago sert les personnes dans le besoin. Laissez-nous vous aider aujourd'hui.",
    howToProceed: "Comment souhaitez-vous procéder?",
    startIntake: "Commencer un Nouveau Formulaire",
    firstVisit: "Première Visite",
    firstVisitSubtitle: "Je suis nouveau au Centre Pape François",
    beenHereBefore: "Je Suis Déjà Venu",
    beenHereBeforeSubtitle: "Client existant — recherchez-moi par nom et date de naissance",
    returningClient: "Client Existant",
    returningLookupTitle: "Bon retour!",
    returningLookupHelp: "Veuillez entrer votre nom et votre date de naissance pour rechercher votre dossier.",
    lookingUp: "Recherche...",
    clientNotFound: "Nous n'avons pas trouvé de dossier correspondant à ces informations.",
    clientNotFoundHelp: "Veuillez vérifier l'orthographe et réessayer, ou choisir une autre option.",
    tryAgain: "Réessayer",
    requestCaseManager: "Demander l'Aide d'un Gestionnaire de Cas",
    continueAsNew: "Continuer comme Nouveau Client",
    caseManagerFlagged: "Un gestionnaire de cas a été notifié. Veuillez vous asseoir — quelqu'un viendra vous voir sous peu.",
    welcomeBackReview: "Bon retour! Veuillez vérifier vos informations et mettre à jour tout ce qui a changé, puis sélectionnez les services dont vous avez besoin aujourd'hui.",
    foundYou: "Nous avons trouvé votre dossier!",
    continueBtn: "Continuer",
    lookUpMe: "Rechercher",
    staffLogin: "Connexion du Personnel",
    needAssistance: "Si vous avez besoin d'aide, demandez à un membre du personnel ou envoyez un courriel à support@popefranciscenter-svdp.org",
    
    // Language selector
    selectLanguage: "Choisir la Langue",
    english: "English",
    spanish: "Español",
    french: "Français",
    polish: "Polski",
    
    // Audio/TTS
    ttsDemographics: "Informations Personnelles. Veuillez entrer votre nom, date de naissance et genre.",
    ttsContact: "Contact et Adresse. Veuillez entrer votre adresse, numéro de téléphone et contact d'urgence.",
    ttsLiving: "Situation de Logement. Parlez-nous de votre logement actuel et de votre foyer.",
    ttsServices: "Qu'est-ce qui vous a amené au Centre Pape François aujourd'hui? Veuillez sélectionner tous les services dont vous avez besoin.",
    ttsConsent: "Veuillez examiner et signer les formulaires de consentement.",
    
    // Navigation
    next: "Suivant",
    previous: "Précédent",
    cancel: "Annuler",
    submit: "Soumettre le Formulaire",
    submitting: "Envoi en cours...",
    backToHome: "Retour à l'Accueil",
    back: "Retour",
    
    // Steps
    step: "Étape",
    of: "sur",
    
    // Step titles
    personalInfo: "Informations Personnelles",
    contactAddress: "Contact et Adresse",
    emergencyContact: "Contact d'Urgence",
    demographics: "Démographie",
    livingSituation: "Situation de Logement",
    yourNeeds: "Vos Besoins",
    household: "Informations sur le Ménage",
    incomeAndBenefits: "Revenus et Prestations",
    consent: "Consentement",
    
    // Personal Info
    tellUsAboutYourself: "Veuillez nous parler de vous.",
    firstName: "Prénom",
    lastName: "Nom de Famille",
    middleInitial: "Initiale du Deuxième Prénom",
    dateOfBirth: "Date de Naissance",
    month: "Mois",
    day: "Jour",
    year: "Année",
    ssn: "Numéro de Sécurité Sociale (Optionnel)",
    gender: "Genre",
    male: "Homme",
    female: "Femme",
    other: "Autre",
    preferNotToSay: "Préfère ne pas dire",
    
    // Contact
    streetAddress: "Adresse",
    city: "Ville",
    state: "État",
    zipCode: "Code Postal",
    phoneNumber: "Numéro de Téléphone",
    emailAddress: "Adresse E-mail",
    
    // Emergency Contact
    contactName: "Nom du Contact",
    contactPhone: "Téléphone du Contact",
    discretionRequired: "Devons-nous faire attention à ce que nous disons en appelant cette personne?",
    emergencyContactDesc: "Veuillez fournir quelqu'un que nous pouvons contacter en cas d'urgence.",
    
    // Demographics
    hispanicLatino: "Êtes-vous Hispanique/Latino?",
    yes: "Oui",
    no: "Non",
    race: "Race (sélectionnez tout ce qui s'applique)",
    asian: "Asiatique",
    blackAfricanAmerican: "Noir ou Afro-Américain",
    nativeHawaiian: "Hawaïen/Îles du Pacifique",
    white: "Blanc",
    americanIndian: "Amérindien",
    alaskaNative: "Natif de l'Alaska",
    relationshipStatus: "Situation Matrimoniale",
    single: "Célibataire",
    singleLivingWithPartner: "Célibataire Vivant avec un Partenaire",
    married: "Marié(e)",
    divorced: "Divorcé(e)",
    separated: "Séparé(e)",
    widowed: "Veuf/Veuve",
    
    // Living Situation
    selectLivingSituation: "Veuillez sélectionner votre situation de logement actuelle.",
    onStreet: "Dans la Rue",
    shelter: "Refuge",
    transitional: "Logement de Transition",
    groupHome: "Foyer de Groupe",
    drugTreatment: "Résidence de Traitement",
    sro: "SRO",
    rental: "Permanent/Location",
    ownHome: "Propriétaire",
    familyFriends: "Famille/Amis",
    temporary: "Temporaire",
    pleaseSpecify: "Veuillez préciser",
    
    // Needs
    howDidYouHear: "Comment avez-vous entendu parler du Centre Pape François?",
    referralPlaceholder: "Ami, église, site web, etc.",
    whatDoYouNeed: "De quoi avez-vous besoin aujourd'hui?",
    needsPlaceholder: "Veuillez décrire vos besoins immédiats et votre situation...",
    
    // Household
    householdSize: "Taille du Ménage (vous compris)",
    numberOfAdults: "Nombre d'Adultes",
    numberOfChildren: "Nombre d'Enfants",
    tellUsAboutHousehold: "Parlez-nous de qui vit dans votre foyer.",
    
    // Income
    monthlyIncomeTitle: "Revenus et Prestations Mensuels",
    incomeDescription: "Entrez vos revenus mensuels de chaque source (laissez vide si aucun).",
    employment: "Emploi",
    socialSecurity: "Sécurité Sociale",
    ssi: "SSI",
    ssd: "SSD",
    childSupport: "Pension Alimentaire",
    tanf: "TANF",
    foodStamps: "Bons Alimentaires",
    unemployment: "Chômage",
    veteransAssistance: "Aide aux Vétérans",
    pension: "Retraite",
    disabilityInsurance: "Assurance Invalidité",
    otherIncome: "Autres Revenus",
    totalMonthlyIncome: "Revenu Mensuel Total",
    additionalHouseholdIncome: "Revenus Supplémentaires des Autres Membres du Ménage",
    
    // Services
    whatBroughtYou: "Qu'est-ce qui vous amène au Centre Pape François aujourd'hui?",
    selectServices: "Veuillez sélectionner tous les services dont vous avez besoin. Nous sommes là pour vous servir.",
    servicesSelected: "Services sélectionnés",
    tellUsWhatYouNeed: "Dites-nous ce dont vous avez besoin",
    describeNeeds: "Veuillez décrire ce qui vous amène ici aujourd'hui...",
    serviceHomelessness: "Aide pour les problèmes de sans-abrisme",
    serviceHousing: "Aide au logement (demande de logement)",
    serviceBenefits: "Prestations publiques (LINK, TANF, Medicaid, etc.)",
    serviceReferrals: "Références de ressources (banque alimentaire, ESL, immigration, réinsertion, soins de santé)",
    serviceFinancial: "Conseils en éducation financière",
    serviceJob: "Préparation à l'emploi (CV, recherche d'emploi, candidatures)",
    serviceMailDrop: "Services de boîte postale (utiliser PFC comme adresse)",
    serviceNotary: "Dispense pour les Sans-Abri",
    servicePfcId: "Carte d'identité du Centre Pape François",
    serviceId: "Aide pour certificat de naissance / carte d'identité",
    serviceInternet: "Aide et accès Internet",
    
    // Consent
    informedConsent: "Consentement Éclairé",
    informedConsentText: "J'autorise le Centre Pape François de Chicago à collecter des informations lors du processus d'inscription. Ce formulaire de consentement comprend toutes les questions me concernant, ma famille, mon historique professionnel, mes antécédents médicaux, mes antécédents de santé mentale et ma consommation de drogues et/ou d'alcool. Cela inclut tous les rendez-vous pris pour moi et l'aide fournie par le Centre Pape François de Chicago. Je comprends que je peux refuser de parler de santé mentale, de consommation d'alcool et de drogues. Je donne mon consentement dans les limites de mon autorité légale. Je comprends que je peux retirer ce consentement à tout moment par écrit. Une photocopie/fax de ce consentement sera légalement identique à l'original.",
    consentIntro: "Veuillez lire et accepter les formulaires de consentement suivants en fonction des services que vous avez sélectionnés.",
    iAgree: "J'accepte les termes ci-dessus",
    signature: "Signature",
    clear: "Effacer",
    mailDropConsent: "Consentement pour le Courrier (Optionnel)",
    mailDropText: "PFC offre des services de boîte postale non officiels. Le courrier ne peut être récupéré que par vous avec une pièce d'identité valide. Le courrier sera conservé pendant 2 semaines seulement.",
    useMailDrop: "Je souhaite utiliser le service de boîte postale",
    idCardConsent: "Consentement pour la Carte d'Identité (Optionnel)",
    idCardText: "PFC offre des cartes d'identité non officielles pour les clients actifs, uniquement pour usage PFC. Cette carte peut être utilisée pour récupérer le courrier et recevoir des services lors des événements PFC.",
    receiveIdCard: "Je souhaite recevoir une carte d'identité PFC",
    doNotShare: "Informations que je ne veux PAS partager (optionnel):",
    doNotSharePlaceholder: "Listez toute information que vous souhaitez garder confidentielle...",
    
    // Success
    thankYou: "Merci!",
    submissionSuccess: "Votre formulaire d'admission a été soumis avec succès.",
    yourClientId: "Votre ID Client",
    caseManagerContact: "Un gestionnaire de cas examinera vos informations et vous contactera bientôt. Questions? Courriel: support@popefranciscenter-svdp.org",
    
    // Login
    signIn: "Connexion",
    signInDesc: "Connectez-vous pour accéder au système de gestion des admissions",
    username: "Nom d'utilisateur",
    password: "Mot de passe",
    enterUsername: "Entrez le nom d'utilisateur",
    enterPassword: "Entrez le mot de passe",
    signingIn: "Connexion en cours...",
    backToKiosk: "← Retour au Mode Kiosque",
    welcomeBack: "Bon retour!",
    
    // Dashboard
    intakeDashboard: "Tableau de Bord des Admissions",
    manageIntakes: "Gérer les admissions des clients",
    searchClients: "Rechercher des clients...",
    dashboard: "Tableau de Bord",
    pendingReview: "En Attente de Révision",
    approved: "Approuvé",
    newIntake: "Nouvelle Admission",
    manageUsers: "Gérer les Utilisateurs",
    signOut: "Déconnexion",
    total: "Total",
    pending: "En Attente",
    exported: "Exporté",
    today: "Aujourd'hui",
    allIntakes: "Toutes les Admissions",
    clientId: "ID Client",
    name: "Nom",
    status: "Statut",
    created: "Créé",
    actions: "Actions",
    noIntakesFound: "Aucune admission trouvée",
    
    // Review
    reviewNotes: "Notes de Révision",
    addNotesPlaceholder: "Ajouter des notes sur cette admission...",
    approve: "Approuver",
    reject: "Rejeter",
    exportForServWare: "Exporter pour ServWare",
    submittedOn: "Soumis le",
    via: "via",
    entry: "entrée",
    reviewedBy: "Révisé par",
    on: "le",
    
    // User Management
    addNewUser: "Ajouter un Nouvel Utilisateur",
    fullName: "Nom Complet",
    role: "Rôle",
    admin: "Administrateur",
    caseManager: "Gestionnaire de Cas",
    hospitalityManager: "Responsable de l'Hospitalité",
    createUser: "Créer un Utilisateur",
    creating: "Création en cours...",
    currentUsers: "Utilisateurs Actuels",
    userCreated: "Utilisateur créé",
    userDeleted: "Utilisateur supprimé",
    
    // Misc
    required: "requis",
    optional: "optionnel",
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    
    // Conference Referral
    conferenceReferral: "Référence de Conférence SVdP",
    referralDescription: "Soumettez une référence pour quelqu'un qui a besoin d'aide au Centre Pape François",
    referringConference: "Conférence Référente",
    selectConference: "Sélectionner la Conférence",
    organizationName: "Nom de l'Organisation",
    enterOrgName: "Entrez le nom de l'organisation",
    contactEmail: "Email de Contact",
    contactPhone: "Téléphone de Contact",
    personBeingReferred: "Personne Référée",
    enterFullName: "Entrez le nom complet",
    referralDetails: "Détails de la Référence",
    reasonForReferral: "Raison de la Référence",
    describeReason: "Décrivez pourquoi cette personne est référée...",
    additionalInfo: "Informations Supplémentaires",
    anyOtherInfo: "Toute autre information pertinente...",
    submitReferral: "Soumettre la Référence",
    referralSubmitted: "Référence soumise avec succès!",
    referralReceived: "Votre référence a été reçue. Notre personnel sera notifié et se préparera à aider lorsque le client arrivera.",
    referralId: "ID de Référence",
    pleaseFillRequired: "Veuillez remplir tous les champs obligatoires",
    pleaseProvideOrgName: "Veuillez fournir le nom de votre organisation",
    pendingReferrals: "Références en Attente",
    convertToIntake: "Convertir en Admission",
    cancelReferral: "Annuler la Référence",
    referralConverted: "Référence convertie en admission",
    referralCancelled: "Référence annulée",
  },
  
  pl: {
    // Kiosk Home
    welcome: "Witamy",
    welcomeMessage: "Centrum Papieża Franciszka w Chicago służy potrzebującym. Pozwól nam pomóc Ci dzisiaj.",
    howToProceed: "Jak chciałbyś kontynuować?",
    startIntake: "Rozpocznij Nowy Formularz",
    firstVisit: "Pierwsza Wizyta",
    firstVisitSubtitle: "Jestem nowy w Centrum Papieża Franciszka",
    beenHereBefore: "Byłem Tu Wcześniej",
    beenHereBeforeSubtitle: "Powracający klient — wyszukaj mnie po imieniu i dacie urodzenia",
    returningClient: "Powracający Klient",
    returningLookupTitle: "Witamy ponownie!",
    returningLookupHelp: "Wprowadź swoje imię i datę urodzenia, aby odnaleźć Twój rekord.",
    lookingUp: "Wyszukiwanie...",
    clientNotFound: "Nie znaleźliśmy rekordu pasującego do tych danych.",
    clientNotFoundHelp: "Sprawdź pisownię i spróbuj ponownie lub wybierz inną opcję.",
    tryAgain: "Spróbuj Ponownie",
    requestCaseManager: "Poproś o Pomoc Opiekuna Przypadku",
    continueAsNew: "Kontynuuj jako Nowy Klient",
    caseManagerFlagged: "Opiekun przypadku został powiadomiony. Prosimy usiąść — ktoś wkrótce do Ciebie podejdzie.",
    welcomeBackReview: "Witamy ponownie! Przejrzyj swoje dane i zaktualizuj to, co się zmieniło, a następnie wybierz usługi, których potrzebujesz dzisiaj.",
    foundYou: "Znaleźliśmy Twój rekord!",
    continueBtn: "Kontynuuj",
    lookUpMe: "Wyszukaj Mnie",
    staffLogin: "Logowanie Personelu",
    needAssistance: "Jeśli potrzebujesz pomocy, poproś członka personelu lub napisz na support@popefranciscenter-svdp.org",
    
    // Language selector
    selectLanguage: "Wybierz Język",
    english: "English",
    spanish: "Español",
    french: "Français",
    polish: "Polski",
    
    // Audio/TTS
    ttsDemographics: "Dane Osobowe. Proszę podać swoje imię, datę urodzenia i płeć.",
    ttsContact: "Kontakt i Adres. Proszę podać swój adres, numer telefonu i kontakt awaryjny.",
    ttsLiving: "Sytuacja Mieszkaniowa. Opowiedz nam o swoim obecnym mieszkaniu i gospodarstwie domowym.",
    ttsServices: "Co sprowadziło Cię dziś do Centrum Papieża Franciszka? Proszę wybrać wszystkie usługi, których potrzebujesz.",
    ttsConsent: "Proszę przejrzeć i podpisać formularze zgody.",
    
    // Navigation
    next: "Dalej",
    previous: "Wstecz",
    cancel: "Anuluj",
    submit: "Wyślij Formularz",
    submitting: "Wysyłanie...",
    backToHome: "Powrót do Strony Głównej",
    back: "Wróć",
    
    // Steps
    step: "Krok",
    of: "z",
    
    // Step titles
    personalInfo: "Dane Osobowe",
    contactAddress: "Kontakt i Adres",
    emergencyContact: "Kontakt Awaryjny",
    demographics: "Demografia",
    livingSituation: "Sytuacja Mieszkaniowa",
    yourNeeds: "Twoje Potrzeby",
    household: "Informacje o Gospodarstwie Domowym",
    incomeAndBenefits: "Dochody i Świadczenia",
    consent: "Zgoda",
    
    // Personal Info
    tellUsAboutYourself: "Proszę opowiedzieć nam o sobie.",
    firstName: "Imię",
    lastName: "Nazwisko",
    middleInitial: "Inicjał Drugiego Imienia",
    dateOfBirth: "Data Urodzenia",
    month: "Miesiąc",
    day: "Dzień",
    year: "Rok",
    ssn: "Numer Ubezpieczenia Społecznego (Opcjonalnie)",
    gender: "Płeć",
    male: "Mężczyzna",
    female: "Kobieta",
    other: "Inna",
    preferNotToSay: "Wolę nie mówić",
    
    // Contact
    streetAddress: "Adres",
    city: "Miasto",
    state: "Stan",
    zipCode: "Kod Pocztowy",
    phoneNumber: "Numer Telefonu",
    emailAddress: "Adres E-mail",
    
    // Emergency Contact
    contactName: "Imię i Nazwisko Kontaktu",
    contactPhone: "Telefon Kontaktowy",
    discretionRequired: "Czy powinniśmy uważać na to, co mówimy dzwoniąc do tej osoby?",
    emergencyContactDesc: "Proszę podać osobę, z którą możemy się skontaktować w nagłych wypadkach.",
    
    // Demographics
    hispanicLatino: "Czy jesteś Latynos/Latynoski?",
    yes: "Tak",
    no: "Nie",
    race: "Rasa (zaznacz wszystkie pasujące)",
    asian: "Azjata",
    blackAfricanAmerican: "Czarnoskóry lub Afroamerykanin",
    nativeHawaiian: "Hawajczyk/Wyspy Pacyfiku",
    white: "Biały",
    americanIndian: "Indianin Amerykański",
    alaskaNative: "Rdzenni Mieszkańcy Alaski",
    relationshipStatus: "Stan Cywilny",
    single: "Singiel/Singielka",
    singleLivingWithPartner: "Singiel/Singielka Mieszkający z Partnerem",
    married: "Żonaty/Zamężna",
    divorced: "Rozwiedziony/Rozwiedziona",
    separated: "W Separacji",
    widowed: "Wdowiec/Wdowa",
    
    // Living Situation
    selectLivingSituation: "Proszę wybrać swoją obecną sytuację mieszkaniową.",
    onStreet: "Na Ulicy",
    shelter: "Schronisko",
    transitional: "Mieszkanie Przejściowe",
    groupHome: "Dom Grupowy",
    drugTreatment: "Ośrodek Leczenia Uzależnień",
    sro: "SRO",
    rental: "Stałe/Wynajem",
    ownHome: "Własny Dom",
    familyFriends: "Rodzina/Przyjaciele",
    temporary: "Tymczasowe",
    pleaseSpecify: "Proszę określić",
    
    // Needs
    howDidYouHear: "Jak dowiedziałeś się o Centrum Papieża Franciszka?",
    referralPlaceholder: "Przyjaciel, kościół, strona internetowa, itp.",
    whatDoYouNeed: "W czym potrzebujesz dzisiaj pomocy?",
    needsPlaceholder: "Proszę opisać swoje pilne potrzeby i sytuację...",
    
    // Household
    householdSize: "Wielkość Gospodarstwa Domowego (włącznie z Tobą)",
    numberOfAdults: "Liczba Dorosłych",
    numberOfChildren: "Liczba Dzieci",
    tellUsAboutHousehold: "Opowiedz nam o osobach mieszkających w Twoim gospodarstwie domowym.",
    
    // Income
    monthlyIncomeTitle: "Miesięczne Dochody i Świadczenia",
    incomeDescription: "Wpisz swoje miesięczne dochody z każdego źródła (zostaw puste jeśli brak).",
    employment: "Zatrudnienie",
    socialSecurity: "Ubezpieczenie Społeczne",
    ssi: "SSI",
    ssd: "SSD",
    childSupport: "Alimenty",
    tanf: "TANF",
    foodStamps: "Bony Żywnościowe",
    unemployment: "Bezrobocie",
    veteransAssistance: "Pomoc dla Weteranów",
    pension: "Emerytura",
    disabilityInsurance: "Ubezpieczenie Niepełnosprawności",
    otherIncome: "Inne Dochody",
    totalMonthlyIncome: "Całkowity Miesięczny Dochód",
    additionalHouseholdIncome: "Dodatkowe Dochody od Innych Członków Gospodarstwa Domowego",
    
    // Services
    whatBroughtYou: "Co Cię dzisiaj sprowadziło do Centrum Papieża Franciszka?",
    selectServices: "Proszę wybrać wszystkie usługi, z którymi potrzebujesz pomocy. Jesteśmy tu, aby Ci służyć.",
    servicesSelected: "Wybrane usługi",
    tellUsWhatYouNeed: "Proszę powiedz nam, czego potrzebujesz",
    describeNeeds: "Proszę opisz, co Cię tu dzisiaj sprowadziło...",
    serviceHomelessness: "Pomoc w kwestiach bezdomności",
    serviceHousing: "Pomoc mieszkaniowa (składanie wniosków o mieszkanie)",
    serviceBenefits: "Świadczenia publiczne (LINK, TANF, Medicaid, itp.)",
    serviceReferrals: "Skierowania do zasobów (bank żywności, ESL, imigracja, reintegracja, opieka zdrowotna)",
    serviceFinancial: "Doradztwo w zakresie edukacji finansowej",
    serviceJob: "Przygotowanie do pracy (CV, poszukiwanie pracy, aplikacje)",
    serviceMailDrop: "Usługi skrzynki pocztowej (używaj PFC jako adresu)",
    serviceNotary: "Zwolnienie dla Bezdomnych",
    servicePfcId: "Identyfikator Centrum Papieża Franciszka",
    serviceId: "Pomoc z aktem urodzenia / dowodem tożsamości",
    serviceInternet: "Pomoc i dostęp do Internetu",
    
    // Consent
    informedConsent: "Świadoma Zgoda",
    informedConsentText: "Upoważniam Centrum Papieża Franciszka w Chicago do zbierania informacji podczas procesu rejestracji. Ten formularz zgody obejmuje wszystkie pytania dotyczące mnie, mojej rodziny, historii zatrudnienia, historii medycznej, historii zdrowia psychicznego oraz używania narkotyków i/lub alkoholu. Obejmuje to wszystkie spotkania umówione dla mnie i pomoc udzieloną mi przez Centrum Papieża Franciszka w Chicago. Rozumiem, że mogę odmówić rozmowy o zdrowiu psychicznym, używaniu alkoholu i narkotyków. Daję moją zgodę w granicach mojego prawnego upoważnienia. Rozumiem, że mogę cofnąć tę zgodę w dowolnym momencie na piśmie. Kserokopia/faks tej zgody będzie prawnie równoważna z oryginałem.",
    consentIntro: "Proszę przejrzeć i zaakceptować poniższe formularze zgody na podstawie wybranych usług.",
    iAgree: "Zgadzam się z powyższymi warunkami",
    signature: "Podpis",
    clear: "Wyczyść",
    mailDropConsent: "Zgoda na Skrzynkę Pocztową (Opcjonalnie)",
    mailDropText: "PFC oferuje nieoficjalne usługi skrzynki pocztowej. Pocztę może odebrać tylko osoba z ważnym dokumentem tożsamości. Poczta będzie przechowywana tylko przez 2 tygodnie.",
    useMailDrop: "Chciałbym korzystać z usługi skrzynki pocztowej",
    idCardConsent: "Zgoda na Kartę Identyfikacyjną (Opcjonalnie)",
    idCardText: "PFC oferuje nieoficjalne karty identyfikacyjne dla aktywnych klientów, tylko do użytku PFC. Ta karta może być używana do odbierania poczty i otrzymywania usług na wydarzeniach PFC.",
    receiveIdCard: "Chciałbym otrzymać kartę identyfikacyjną PFC",
    doNotShare: "Informacje, których NIE chcę udostępniać (opcjonalnie):",
    doNotSharePlaceholder: "Wymień wszelkie informacje, które chcesz zachować w poufności...",
    
    // Success
    thankYou: "Dziękujemy!",
    submissionSuccess: "Twój formularz przyjęcia został pomyślnie przesłany.",
    yourClientId: "Twój Numer Klienta",
    caseManagerContact: "Opiekun sprawy przejrzy Twoje informacje i wkrótce się z Tobą skontaktuje. Pytania? Email: support@popefranciscenter-svdp.org",
    
    // Login
    signIn: "Zaloguj się",
    signInDesc: "Zaloguj się, aby uzyskać dostęp do systemu zarządzania przyjęciami",
    username: "Nazwa użytkownika",
    password: "Hasło",
    enterUsername: "Wprowadź nazwę użytkownika",
    enterPassword: "Wprowadź hasło",
    signingIn: "Logowanie...",
    backToKiosk: "← Powrót do Trybu Kiosku",
    welcomeBack: "Witamy ponownie!",
    
    // Dashboard
    intakeDashboard: "Panel Przyjęć",
    manageIntakes: "Zarządzaj zgłoszeniami klientów",
    searchClients: "Szukaj klientów...",
    dashboard: "Panel",
    pendingReview: "Oczekujące na Przegląd",
    approved: "Zatwierdzone",
    newIntake: "Nowe Przyjęcie",
    manageUsers: "Zarządzaj Użytkownikami",
    signOut: "Wyloguj się",
    total: "Razem",
    pending: "Oczekujące",
    exported: "Wyeksportowane",
    today: "Dzisiaj",
    allIntakes: "Wszystkie Przyjęcia",
    clientId: "ID Klienta",
    name: "Imię i Nazwisko",
    status: "Status",
    created: "Utworzono",
    actions: "Akcje",
    noIntakesFound: "Nie znaleziono przyjęć",
    
    // Review
    reviewNotes: "Notatki z Przeglądu",
    addNotesPlaceholder: "Dodaj notatki o tym przyjęciu...",
    approve: "Zatwierdź",
    reject: "Odrzuć",
    exportForServWare: "Eksportuj do ServWare",
    submittedOn: "Przesłano",
    via: "przez",
    entry: "wpis",
    reviewedBy: "Przejrzane przez",
    on: "dnia",
    
    // User Management
    addNewUser: "Dodaj Nowego Użytkownika",
    fullName: "Pełne Imię i Nazwisko",
    role: "Rola",
    admin: "Administrator",
    caseManager: "Opiekun Sprawy",
    hospitalityManager: "Kierownik Gościnności",
    createUser: "Utwórz Użytkownika",
    creating: "Tworzenie...",
    currentUsers: "Obecni Użytkownicy",
    userCreated: "Użytkownik utworzony",
    userDeleted: "Użytkownik usunięty",
    
    // Misc
    required: "wymagane",
    optional: "opcjonalne",
    loading: "Ładowanie...",
    error: "Błąd",
    success: "Sukces",
    
    // Conference Referral
    conferenceReferral: "Skierowanie z Konferencji SVdP",
    referralDescription: "Prześlij skierowanie dla kogoś, kto potrzebuje pomocy w Centrum Papieża Franciszka",
    referringConference: "Konferencja Kierująca",
    selectConference: "Wybierz Konferencję",
    organizationName: "Nazwa Organizacji",
    enterOrgName: "Wprowadź nazwę organizacji",
    contactEmail: "Email Kontaktowy",
    contactPhone: "Telefon Kontaktowy",
    personBeingReferred: "Osoba Kierowana",
    enterFullName: "Wprowadź pełne imię i nazwisko",
    referralDetails: "Szczegóły Skierowania",
    reasonForReferral: "Powód Skierowania",
    describeReason: "Opisz dlaczego ta osoba jest kierowana...",
    additionalInfo: "Dodatkowe Informacje",
    anyOtherInfo: "Wszelkie inne istotne informacje...",
    submitReferral: "Prześlij Skierowanie",
    referralSubmitted: "Skierowanie przesłane pomyślnie!",
    referralReceived: "Twoje skierowanie zostało otrzymane. Nasz personel zostanie powiadomiony i przygotuje się do pomocy gdy klient przybędzie.",
    referralId: "ID Skierowania",
    pleaseFillRequired: "Proszę wypełnić wszystkie wymagane pola",
    pleaseProvideOrgName: "Proszę podać nazwę organizacji",
    pendingReferrals: "Oczekujące Skierowania",
    convertToIntake: "Konwertuj na Przyjęcie",
    cancelReferral: "Anuluj Skierowanie",
    referralConverted: "Skierowanie przekonwertowane na przyjęcie",
    referralCancelled: "Skierowanie anulowane",
  }
};

export default translations;
